
// import React, { useEffect, useState } from "react";
// import {
//     Grid,
//     Card,
//     CardContent,
//     Typography,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     TextField,
//     Button,
//     Box,
//     Divider,
//     Collapse,
//     Chip,Table,TableCell,TableContainer,TableRow,
//     TableHead, Cell, List,ListItem,ListItemText,Legend,TableBody,Paper
// } from "@mui/material";
// import { BarChart, Bar, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, 
//     CartesianGrid, LineChart, PieChart,Pie



// } from "recharts";
// import PaymentServices from '../../services/externalServices/TicketServices/paymentServices'
// import TheatreServices from '../../services/externalServices/TicketServices/theatreServices'


// import MovieServices from "../../services/externalServices/TicketServices/moviesServices";


// import axios from 'axios'

// import ScreenLayoutServices from "../../services/externalServices/TicketServices/screenLayoutServices";



// const Report = () => {
//     const [movieName, setMovieName] = useState("");
//     const [theatreName, setTheatreName] = useState("");
//     const [showDate, setShowDate] = useState("");
//     const [hour, setHour] = useState("10");
//     const [minute, setMinute] = useState("30");
//     const [period, setPeriod] = useState("PM");
//     const [summaryData, setSummaryData] = useState(null);

//     const [movies, setMovies] = useState([]);
//     const [theatres, setTheatres] = useState([]);
//     const [filterType, setFilterType] = useState("week");
//     const [reportData, setReportData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [selectedTheatre, setSelectedTheatre] = useState("");

//     const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));

//     const [customStartDate, setCustomStartDate] = useState(null);
//     const [customEndDate, setCustomEndDate] = useState(null);


//     useEffect(() => {
//         const fetchData = async () => {
//             const movies = await MovieServices.getMovies();
//             setMovies(movies);

//             const res = await TheatreServices.getTheatres();
//             if (Array.isArray(res)) {
//                 let filtered = res;
//                 if (role === "ticket-admin") filtered = res.filter(t => accessList.includes(t.name));
//                 setTheatres(filtered);
//                 if (filtered.length > 0) setTheatreName(filtered[0].name);
//             }
//         };
//         fetchData();
//     }, []);



//     useEffect(() => {
//         const fetchTheatres = async () => {
//             try {
//                 const res = await TheatreServices.getTheatres();
//                 if (Array.isArray(res)) {
//                     let filteredTheatres = res;

//                     // For ticket-admin, filter theatres by accessList
//                     if (role === "ticket-admin") {
//                         filteredTheatres = res.filter((theatre) => accessList.includes(theatre.name));
//                     }

//                     setTheatres(filteredTheatres);

//                     // For ticket-admin, set the first theatre from the accessList, or fallback to the first available theatre
//                     if (filteredTheatres.length > 0) {
//                         setSelectedTheatre(filteredTheatres[0].name);
//                     }
//                 }
//             } catch (err) {
//                 console.error("Error fetching theatres:", err);
//             }
//         };
//         fetchTheatres();
//     }, []);


//     const handleSummarySubmit = async (e) => {
//         e.preventDefault()
//         const formattedTime = `${hour}:${minute} ${period}`;
//         const params = {
//             movieName,
//             theatreName,
//             showDate: showDate.replace(/-/g, "/"),
//             showTime: formattedTime,
//         };
//         try {
//             const res = await ScreenLayoutServices.getSummary(params);
//             setSummaryData(res);
//         } catch (err) {
//             console.error("Error fetching summary:", err);
//         }
//     };

//     useEffect(() => {
//         const fetchReport = async () => {
//             if (!selectedTheatre || theatres.length === 0) {
//                 setLoading(false); // Stop loading if no theatres are available or selected.
//                 return;
//             }
//             if (filterType === "custom" && (!customStartDate || !customEndDate)) {
//                 return; // don't fetch until both dates are selected
//             }

//             setLoading(true);
//             try {

//                 const response = await PaymentServices.getReports({
//                     theatreName: selectedTheatre,
//                     filterType,
//                     ...(filterType === "custom" && customStartDate && customEndDate
//                         ? { startDate: customStartDate, endDate: customEndDate }
//                         : {}),
//                 });
//                 // const response = await PaymentServices.getReports({
//                 //     theatreName: selectedTheatre,
//                 //     filterType,
//                 // });

//                 if (Array.isArray(response.data)) {
//                     setReportData(response.data);
//                     setLoading(false);
//                 } else {
//                     setReportData([]);

//                     setLoading(false);
//                 }
//             } catch (error) {
//                 console.error("Error fetching report:", error);
//                 setReportData([]); // In case of error, ensure reportData is empty.
//             } finally {
//                 setLoading(false); // Always stop loading after fetching is done, regardless of success or failure.
//             }
//         };

//         fetchReport();
//     }, [selectedTheatre, filterType, theatres, customStartDate, customEndDate]);

//     const totalEarnings = reportData.reduce((sum, entry) => sum + entry.totalAmount, 0);

//     const getAggregatedChartData = (data, filterType, customStartDate = null, customEndDate = null) => {
//         const today = new Date();
//         const grouped = {};

//         // Step 1: Group data by YYYY-MM-DD (for easy matching)
//         data.forEach(entry => {
//             const date = new Date(entry.date);
//             const key = date.toISOString().split('T')[0]; // 'YYYY-MM-DD'
//             if (!grouped[key]) grouped[key] = 0;
//             grouped[key] += entry.totalAmount;
//         });

//         const result = [];

//         // Step 2: Generate date range based on filterType
//         if (filterType === "week") {
//             for (let i = 6; i >= 0; i--) {
//                 const date = new Date(today);
//                 date.setDate(today.getDate() - i);
//                 const key = date.toISOString().split('T')[0];
//                 const label = `${String(date.getDate()).padStart(2, '0')} ${date.toLocaleString('default', { month: 'short' })} (${date.toLocaleString('default', { weekday: 'short' })})`;
//                 result.push({
//                     date: label,
//                     totalAmount: grouped[key] || 0
//                 });
//             }
//         } else if (filterType === "month") {
//             const year = today.getFullYear();
//             const month = today.getMonth();
//             const daysInMonth = new Date(year, month + 1, 0).getDate();

//             for (let i = 1; i <= daysInMonth; i++) {
//                 const date = new Date(year, month, i);
//                 const key = date.toISOString().split('T')[0];
//                 const label = `${String(i).padStart(2, '0')} ${date.toLocaleString('default', { month: 'short' })}`;
//                 result.push({
//                     date: label,
//                     totalAmount: grouped[key] || 0
//                 });
//             }
//         } else if (filterType === "year") {
//             const year = today.getFullYear();
//             for (let i = 0; i < 12; i++) {
//                 const date = new Date(year, i, 1);
//                 const key = `${year}-${String(i + 1).padStart(2, '0')}`; // '2025-01'
//                 const totalForMonth = Object.keys(grouped).reduce((sum, k) => {
//                     if (k.startsWith(key)) sum += grouped[k];
//                     return sum;
//                 }, 0);

//                 result.push({
//                     date: date.toLocaleString('default', { month: 'short' }),
//                     totalAmount: totalForMonth
//                 });
//             }
//         } else if (filterType === "custom") {
//             if (!customStartDate || !customEndDate) return [];

//             const start = new Date(customStartDate);
//             const end = new Date(customEndDate);

//             const current = new Date(start);
//             while (current <= end) {
//                 const key = current.toISOString().split('T')[0];
//                 const label = `${String(current.getDate()).padStart(2, '0')} ${current.toLocaleString('default', { month: 'short' })} (${current.toLocaleString('default', { weekday: 'short' })})`;
//                 result.push({
//                     date: label,
//                     totalAmount: grouped[key] || 0
//                 });
//                 current.setDate(current.getDate() + 1);
//             }
//         }









//         // else if (filterType === "custom") {
//         //     const start = new Date("2025-04-01"); // You can take from user
//         //     const end = new Date("2025-04-07");   // You can take from user

//         //     const current = new Date(start);
//         //     while (current <= end) {
//         //         const key = current.toISOString().split('T')[0];
//         //         const label = `${String(current.getDate()).padStart(2, '0')} ${current.toLocaleString('default', { month: 'short' })} (${current.toLocaleString('default', { weekday: 'short' })})`;
//         //         result.push({
//         //             date: label,
//         //             totalAmount: grouped[key] || 0
//         //         });
//         //         current.setDate(current.getDate() + 1);
//         //     }
//         // }

//         return result;
//     };

//     return (



//         <Grid container spacing={3} >

//             {/* Left Column: Show Performance & Summary */}
//             <Grid item xs={6} md={12} lg={5}>
//                 {/* Show Performance Form */}
//                 <Card elevation={6} sx={{ mb: 3, backdropFilter: "blur(8px)", background: "rgba(255,255,255,0.85)" }}>
//                     <CardContent>
//                         <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
//                             🎭 Show Performance
//                         </Typography>




//                         <form onSubmit={handleSummarySubmit}>
//                             <Grid container spacing={4}>
//                                 {/* Movie Dropdown */}
//                                 <Grid item xs={12}>
//                                     <FormControl fullWidth size="small" required>
//                                         <InputLabel>Movie</InputLabel>
//                                         <Select
//                                             value={movieName}
//                                             onChange={(e) => setMovieName(e.target.value)}
//                                             label="Movie"
//                                             required
//                                         >
//                                             {movies.map((m) => (
//                                                 <MenuItem key={m._id} value={m.name}>
//                                                     {m.name}
//                                                 </MenuItem>
//                                             ))}
//                                         </Select>
//                                     </FormControl>
//                                 </Grid>

//                                 {/* Theatre Dropdown */}
//                                 <Grid item xs={12}>
//                                     <FormControl fullWidth size="small" required>
//                                         <InputLabel>Theatre</InputLabel>
//                                         <Select
//                                             value={theatreName}
//                                             onChange={(e) => setTheatreName(e.target.value)}
//                                             label="Theatre"
//                                             required
//                                         >
//                                             {theatres.map((t) => (
//                                                 <MenuItem key={t._id} value={t.name}>
//                                                     {t.name}
//                                                 </MenuItem>
//                                             ))}
//                                         </Select>
//                                     </FormControl>
//                                 </Grid>

//                                 {/* Show Date */}
//                                 <Grid item xs={12}>
//                                     <TextField
//                                         label="Show Date"
//                                         type="date"
//                                         value={showDate}
//                                         onChange={(e) => setShowDate(e.target.value)}
//                                         fullWidth
//                                         size="small"
//                                         InputLabelProps={{ shrink: true }}
//                                         required
//                                     />
//                                 </Grid>

//                                 {/* Show Time (Hour, Minute, Period) */}
//                                 <Grid item xs={12}>
//                                     <Grid container spacing={1}>
//                                         <Grid item xs={4}>
//                                             <FormControl fullWidth size="small" required>
//                                                 <InputLabel>Hour</InputLabel>
//                                                 <Select value={hour} onChange={(e) => setHour(e.target.value)} label="Hour" required>
//                                                     {[...Array(12).keys()].map((i) => (
//                                                         <MenuItem key={i + 1} value={String(i + 1).padStart(2, "0")}>
//                                                             {String(i + 1).padStart(2, "0")}
//                                                         </MenuItem>
//                                                     ))}
//                                                 </Select>
//                                             </FormControl>
//                                         </Grid>
//                                         <Grid item xs={4}>
//                                             <FormControl fullWidth size="small" required>
//                                                 <InputLabel>Minute</InputLabel>
//                                                 <Select value={minute} onChange={(e) => setMinute(e.target.value)} label="Minute" required>
//                                                     {[...Array(60).keys()].map((i) => (
//                                                         <MenuItem key={i} value={String(i).padStart(2, "0")}>
//                                                             {String(i).padStart(2, "0")}
//                                                         </MenuItem>
//                                                     ))}
//                                                 </Select>
//                                             </FormControl>
//                                         </Grid>
//                                         <Grid item xs={4}>
//                                             <FormControl fullWidth size="small" required>
//                                                 <InputLabel>AM/PM</InputLabel>
//                                                 <Select value={period} onChange={(e) => setPeriod(e.target.value)} label="AM/PM" required>
//                                                     <MenuItem value="AM">AM</MenuItem>
//                                                     <MenuItem value="PM">PM</MenuItem>
//                                                 </Select>
//                                             </FormControl>
//                                         </Grid>
//                                     </Grid>
//                                 </Grid>

//                                 {/* Submit Button */}
//                                 <Grid item xs={12}>
//                                     <Button
//                                         type="submit"
//                                         variant="contained"
//                                         fullWidth
//                                         sx={{ backgroundColor: "#000", "&:hover": { backgroundColor: "#333" } }}
//                                     >
//                                         Get Summary
//                                     </Button>
//                                 </Grid>
//                             </Grid>
//                         </form>


//                     </CardContent>


//                 </Card>


//                 {/* 
//                     {summaryData && (
//                         <Card elevation={6} sx={{ p: 2, mb: 2, backdropFilter: "blur(8px)", background: "rgba(255,255,255,0.85)" }}>
//                             <Typography variant="h6">🎟️ Ticket Summary</Typography>
//                             <Box display="flex" justifyContent="space-between" mt={1}>
//                                 <Typography variant="body1" color="primary">{summaryData.totalBookedSeats} Booked</Typography>
//                                 <Typography variant="body1">💰 ₹{summaryData.totalEarnings}</Typography>
//                             </Box>
//                             <Divider sx={{ my: 1 }} />
//                             <Typography variant="body2" gutterBottom>
//                                 Seats: {summaryData.bookedSeatList?.join(", ")}
//                             </Typography>
//                             <Box display="flex" justifyContent="space-between" mt={1}>
//                                 <Box display="flex" alignItems="center">
//                                     <Box sx={{ width: 10, height: 10, bgcolor: "gold", borderRadius: "50%", mr: 1 }} />
//                                     <Typography variant="caption">In Stock: {100 - summaryData.totalBookedSeats}</Typography>
//                                 </Box>
//                                 <Box display="flex" alignItems="center">
//                                     <Box sx={{ width: 10, height: 10, bgcolor: "green", borderRadius: "50%", mr: 1 }} />
//                                     <Typography variant="caption">Sold: {summaryData.totalBookedSeats}</Typography>
//                                 </Box>
//                             </Box>
//                         </Card>
//                     )} */}

//                 {
//                     summaryData && (
//                         <Grid item xs={12}>
//                             <Collapse in={!!summaryData} timeout={300}>
//                                 <Card
//                                     elevation={6}
//                                     sx={{
//                                         p: 2,
//                                         mb: 2,
//                                         backdropFilter: "blur(8px)",
//                                         background: "rgba(255,255,255,0.85)",
//                                     }}
//                                 >
//                                     <Typography variant="h6">🎟️ Ticket Summary</Typography>
//                                     <Box display="flex" justifyContent="space-between" mt={1}>
//                                         <Typography variant="body1" color="primary">{summaryData?.totalBookedSeats} Booked</Typography>
//                                         <Typography variant="body1">💰 ₹{summaryData?.totalEarnings}</Typography>
//                                     </Box>
//                                     <Divider sx={{ my: 1 }} />
//                                     <Typography variant="body2" gutterBottom>
//                                         Seats: {summaryData?.bookedSeatList?.join(", ")}
//                                     </Typography>
//                                     <Box display="flex" justifyContent="space-between" mt={1}>
//                                         <Box display="flex" alignItems="center">
//                                             <Box sx={{ width: 10, height: 10, bgcolor: "gold", borderRadius: "50%", mr: 1 }} />
//                                             <Typography variant="caption">In Stock: {100 - summaryData?.totalBookedSeats}</Typography>
//                                         </Box>
//                                         <Box display="flex" alignItems="center">
//                                             <Box sx={{ width: 10, height: 10, bgcolor: "green", borderRadius: "50%", mr: 1 }} />
//                                             <Typography variant="caption">Sold: {summaryData?.totalBookedSeats}</Typography>
//                                         </Box>
//                                     </Box>
//                                 </Card>
//                             </Collapse>
//                         </Grid>
//                     )
//                 }

//                 {/* Ticket Summary */}

//             </Grid >


//             {/* Right Column: Revenue Report */}
//             < Grid item xs={12} md={12} lg={7} >
//                 <Card elevation={6} sx={{ p: 2, height: "100%", backdropFilter: "blur(8px)", background: "rgba(255,255,255,0.85)" }}>
//                     <Typography variant="h6">💹 Revenue Report</Typography>

//                     <FormControl fullWidth size="small" sx={{ my: 2 }}>
//                         <InputLabel>Filter</InputLabel>
//                         <Select value={filterType} onChange={(e) => setFilterType(e.target.value)} label="Filter">
//                             <MenuItem value="day">Today</MenuItem>
//                             <MenuItem value="week">This Week</MenuItem>
//                             <MenuItem value="month">This Month</MenuItem>
//                             <MenuItem value="year">This Year</MenuItem>
//                             <MenuItem value="custom">Custom</MenuItem>
//                         </Select>
//                     </FormControl>

//                     {filterType === "custom" && (
//                         <Box display="flex" gap={2} mb={2}>
//                             <TextField
//                                 label="Start Date"
//                                 type="date"
//                                 size="small"
//                                 fullWidth
//                                 value={customStartDate || ""}
//                                 onChange={(e) => setCustomStartDate(e.target.value)}
//                                 InputLabelProps={{ shrink: true }}
//                             />
//                             <TextField
//                                 label="End Date"
//                                 type="date"
//                                 size="small"
//                                 fullWidth
//                                 value={customEndDate || ""}
//                                 onChange={(e) => setCustomEndDate(e.target.value)}
//                                 InputLabelProps={{ shrink: true }}
//                             />
//                         </Box>
//                     )}

//                     <Typography variant="body2" gutterBottom>
//                         Total Earnings: ₹{totalEarnings}
//                     </Typography>

//                     {loading ? (
//                         <Typography>Loading chart...</Typography>
//                     ) : (
//                         <Box sx={{ width: "100%", height: 300 }}>
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <LineChart
//                                     data={getAggregatedChartData(reportData, filterType, customStartDate, customEndDate)}
//                                 >
//                                     <CartesianGrid strokeDasharray="3 3" />
//                                     <XAxis dataKey="date" />
//                                     <YAxis />
//                                     <Tooltip />
//                                     <Line type="monotone" dataKey="totalAmount" stroke="#4ade80" strokeWidth={2} dot={{ r: 4 }} />
//                                 </LineChart>
//                             </ResponsiveContainer>
//                         </Box>
//                     )}
//                 </Card>
//             </Grid >
//         </Grid >





//     );
// };

// export default Report;


// Before sepeartion which is in PRD

// import React, { useState, useEffect } from "react";
// import {
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   TextField,
//   Select,
//   MenuItem,
//   Button,
//   InputLabel,
//   FormControl,
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Divider,
//   Collapse,
//   Tabs,
//   Tab,
//   CircularProgress,
//   Chip,
//   TablePagination
// } from "@mui/material";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
//   PieChart,
//   Pie,
//   Cell
// } from "recharts";
// // import MovieServices from "../services/externalServices/TicketServices/moviesServices";
// // import TheatreServices from "../services/externalServices/TicketServices/theatreServices";
// // import ScreenLayoutServices from "../services/externalServices/TicketServices/screenLayoutServices";
// // import PaymentServices from "../services/externalServices/TicketServices/paymentServices";

// import PaymentServices from '../../services/externalServices/TicketServices/paymentServices'
// import TheatreServices from '../../services/externalServices/TicketServices/theatreServices'
// import { Ticket } from "lucide-react";

// import MovieServices from "../../services/externalServices/TicketServices/moviesServices";


// import axios from 'axios'

// import ScreenLayoutServices from "../../services/externalServices/TicketServices/screenLayoutServices";

// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d'];

// const Report = () => {
//   const [movieName, setMovieName] = useState("");
//   const [theatreName, setTheatreName] = useState("");
//   const [showDate, setShowDate] = useState("");
//   const [hour, setHour] = useState("10");
//   const [minute, setMinute] = useState("30");
//   const [period, setPeriod] = useState("PM");
//   const [summaryData, setSummaryData] = useState(null);
//   const [movies, setMovies] = useState([]);
//   const [theatres, setTheatres] = useState([]);
//   const [filterType, setFilterType] = useState("week");
//   const [reportData, setReportData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedTheatre, setSelectedTheatre] = useState("");
//   const [customStartDate, setCustomStartDate] = useState(null);
//   const [customEndDate, setCustomEndDate] = useState(null);
//   const [activeTab, setActiveTab] = useState(0);
//   const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));

//   const isTicketAdmin = role === 'ticket-admin';
//   console.log('isTicketAdmin', isTicketAdmin);
//   const theatreName1 = accessList?.[0]; // assuming accessList contains theatre name





//   // Add new state for pagination
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   // Calculate paginated data
//   const paginatedData = reportData.slice(
//     page * rowsPerPage,
//     page * rowsPerPage + rowsPerPage
//   );

//   // Handle page change
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   // Handle rows per page change
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };


//   useEffect(() => {
//     const fetchData = async () => {

//       const theatreName = theatreName1

//       const movies = await MovieServices.getMovies(theatreName);
//       setMovies(movies);

//       const res = await TheatreServices.getTheatres();
//       if (Array.isArray(res)) {
//         let filtered = res;
//         if (role === "ticket-admin") filtered = res.filter(t => accessList.includes(t.name));
//         setTheatres(filtered);
//         if (filtered.length > 0) setTheatreName(filtered[0].name);
//       }
//     };
//     fetchData();
//   }, []);

//   useEffect(() => {
//     const fetchTheatres = async () => {
//       try {
//         const res = await TheatreServices.getTheatres();
//         if (Array.isArray(res)) {
//           let filteredTheatres = res;
//           if (role === "ticket-admin") {
//             filteredTheatres = res.filter((theatre) => accessList.includes(theatre.name));
//           }
//           setTheatres(filteredTheatres);
//           if (filteredTheatres.length > 0) {
//             setSelectedTheatre(filteredTheatres[0].name);
//           }
//         }
//       } catch (err) {
//         console.error("Error fetching theatres:", err);
//       }
//     };
//     fetchTheatres();
//   }, []);

//   const handleSummarySubmit = async (e) => {
//     e.preventDefault();
//     const formattedTime = `${hour}:${minute} ${period}`;
//     const params = {
//       movieName,
//       theatreName,
//       showDate: showDate.replace(/-/g, "/"),
//       showTime: formattedTime,
//     };
//     try {
//       const res = await ScreenLayoutServices.getSummary(params);
//       setSummaryData(res);
//     } catch (err) {
//       console.error("Error fetching summary:", err);
//     }
//   };

//   useEffect(() => {
//     const fetchReport = async () => {
//       if (!selectedTheatre || theatres.length === 0) {
//         setLoading(false);
//         return;
//       }
//       if (filterType === "custom" && (!customStartDate || !customEndDate)) {
//         return;
//       }

//       setLoading(true);
//       try {
//         const response = await PaymentServices.getReports({
//           theatreName: selectedTheatre,
//           filterType,
//           ...(filterType === "custom" && customStartDate && customEndDate
//             ? { startDate: customStartDate, endDate: customEndDate }
//             : {}),
//         });

//         if (Array.isArray(response.data)) {
//           setReportData(response.data);
//         } else {
//           setReportData([]);
//         }
//       } catch (error) {
//         console.error("Error fetching report:", error);
//         setReportData([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchReport();
//   }, [selectedTheatre, filterType, theatres, customStartDate, customEndDate]);


//   console.log('report data in the report file', reportData)

//   const totalEarnings = reportData.reduce((sum, entry) => sum + (entry.totalAmount || 0), 0);
//   const totalTickets = reportData.reduce((sum, entry) => sum + (entry.bookedSeats?.length || 0), 0);

//   const getAggregatedChartData = (data, filterType, customStartDate = null, customEndDate = null) => {
//     const today = new Date();
//     const grouped = {};

//     data.forEach(entry => {
//       const date = new Date(entry.date);
//       const key = date.toISOString().split('T')[0];
//       if (!grouped[key]) grouped[key] = 0;
//       grouped[key] += entry.totalAmount;
//     });

//     const result = [];

//     if (filterType === "week") {
//       for (let i = 6; i >= 0; i--) {
//         const date = new Date(today);
//         date.setDate(today.getDate() - i);
//         const key = date.toISOString().split('T')[0];
//         const label = `${String(date.getDate()).padStart(2, '0')} ${date.toLocaleString('default', { month: 'short' })} (${date.toLocaleString('default', { weekday: 'short' })})`;
//         result.push({
//           date: label,
//           totalAmount: grouped[key] || 0
//         });
//       }
//     } else if (filterType === "month") {
//       const year = today.getFullYear();
//       const month = today.getMonth();
//       const daysInMonth = new Date(year, month + 1, 0).getDate();

//       for (let i = 1; i <= daysInMonth; i++) {
//         const date = new Date(year, month, i);
//         const key = date.toISOString().split('T')[0];
//         const label = `${String(i).padStart(2, '0')} ${date.toLocaleString('default', { month: 'short' })}`;
//         result.push({
//           date: label,
//           totalAmount: grouped[key] || 0
//         });
//       }
//     } else if (filterType === "year") {
//       const year = today.getFullYear();
//       for (let i = 0; i < 12; i++) {
//         const date = new Date(year, i, 1);
//         const key = `${year}-${String(i + 1).padStart(2, '0')}`;
//         const totalForMonth = Object.keys(grouped).reduce((sum, k) => {
//           if (k.startsWith(key)) sum += grouped[k];
//           return sum;
//         }, 0);

//         result.push({
//           date: date.toLocaleString('default', { month: 'short' }),
//           totalAmount: totalForMonth
//         });
//       }
//     } else if (filterType === "custom") {
//       if (!customStartDate || !customEndDate) return [];

//       const start = new Date(customStartDate);
//       const end = new Date(customEndDate);

//       const current = new Date(start);
//       while (current <= end) {
//         const key = current.toISOString().split('T')[0];
//         const label = `${String(current.getDate()).padStart(2, '0')} ${current.toLocaleString('default', { month: 'short' })} (${current.toLocaleString('default', { weekday: 'short' })})`;
//         result.push({
//           date: label,
//           totalAmount: grouped[key] || 0
//         });
//         current.setDate(current.getDate() + 1);
//       }
//     }

//     return result;
//   };

//   const getRevenueByMovie = () => {
//     const revenueByMovie = {};
//     reportData.forEach(entry => {
//       if (!revenueByMovie[entry.movieName]) {
//         revenueByMovie[entry.movieName] = 0;
//       }
//       revenueByMovie[entry.movieName] += entry.totalAmount;
//     });
//     return Object.entries(revenueByMovie).map(([name, value]) => ({
//       name,
//       value
//     }));
//   };



//   const formatDateToDDMMYYYY = (dateInput) => {
//     if (!dateInput) return '';

//     // Handle both string dates and Date objects
//     const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

//     // Check if the date is valid
//     if (isNaN(date.getTime())) return 'Invalid date';

//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = date.getFullYear();

//     return `${day}-${month}-${year}`;
//   };

//   return (
//     <div className="p-4 space-y-6">
//       {/* Top Section: Show Performance and Ticket Summary */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//         {/* Show Performance Card */}
//         <div className="bg-white rounded-xl shadow-md p-6">
//           <h2 className="text-xl font-semibold mb-4">Show Performance</h2>

//           <form onSubmit={handleSummarySubmit} className="space-y-4">
//             <div className="space-y-2">
//               <label className="block text-sm font-medium text-gray-700">Movie</label>
//               <select
//                 value={movieName}
//                 onChange={(e) => setMovieName(e.target.value)}
//                 className="w-full p-2 border border-gray-300 rounded-md"
//                 required
//               >
//                 <option value="">Select a movie</option>
//                 {movies.map((m) => (
//                   <option key={m._id} value={m.name}>
//                     {m.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="space-y-2">
//               <label className="block text-sm font-medium text-gray-700">Theatre</label>
//               <select
//                 value={theatreName}
//                 onChange={(e) => setTheatreName(e.target.value)}
//                 className="w-full p-2 border border-gray-300 rounded-md"
//                 required
//               >
//                 <option value="">Select a theatre</option>
//                 {theatres.map((t) => (
//                   <option key={t._id} value={t.name}>
//                     {t.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="space-y-2">
//               <label className="block text-sm font-medium text-gray-700">Show Date</label>
//               <input
//                 type="date"
//                 value={showDate}
//                 onChange={(e) => setShowDate(e.target.value)}
//                 className="w-full p-2 border border-gray-300 rounded-md"
//                 required
//               />
//             </div>

//             <div className="grid grid-cols-3 gap-2">
//               <div className="space-y-2">
//                 <label className="block text-sm font-medium text-gray-700">Hour</label>
//                 <select
//                   value={hour}
//                   onChange={(e) => setHour(e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                   required
//                 >
//                   {[...Array(12).keys()].map((i) => (
//                     <option key={i + 1} value={String(i + 1).padStart(2, "0")}>
//                       {String(i + 1).padStart(2, "0")}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div className="space-y-2">
//                 <label className="block text-sm font-medium text-gray-700">Minute</label>
//                 <select
//                   value={minute}
//                   onChange={(e) => setMinute(e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                   required
//                 >
//                   {[...Array(60).keys()].map((i) => (
//                     <option key={i} value={String(i).padStart(2, "0")}>
//                       {String(i).padStart(2, "0")}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div className="space-y-2">
//                 <label className="block text-sm font-medium text-gray-700">AM/PM</label>
//                 <select
//                   value={period}
//                   onChange={(e) => setPeriod(e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                   required
//                 >
//                   <option value="AM">AM</option>
//                   <option value="PM">PM</option>
//                 </select>
//               </div>
//             </div>

//             <button
//               type="submit"
//               className="w-full bg-black text-white py-2 px-4 rounded-md hover:bg-gray-800 transition-colors"
//             >
//               Get Summary
//             </button>
//           </form>
//         </div>

//         {/* Ticket Summary Card */}
//         {summaryData && (
//           <div className="bg-white rounded-xl shadow-md p-6">
//             <h2 className="text-xl font-semibold mb-4 flex gap-2 items-center"> <Ticket/> Ticket Summary</h2>
//             <div className="space-y-4">
//               <div className="flex justify-between">
//                 <span className="font-medium">Booked Seats:</span>
//                 <span className="text-yellow-500">{summaryData.totalBookedSeats}</span>
//               </div>
//               <div className="flex justify-between">
//                 <span className="font-medium">Total Earnings:</span>
//                 <span className="text-green-500">₹{summaryData.totalEarnings}</span>
//               </div>

//               <div>
//                 <h3 className="font-medium mb-2">Seats:</h3>
//                 <div className="flex flex-wrap gap-2 max-h-32 overflow-y-auto p-2 bg-gray-50 rounded">
//                   {summaryData.bookedSeatList.map((seat, idx) => (
//                     <span
//                       key={idx}
//                       className="text-xs px-2 py-1 border border-blue-200 rounded-full bg-blue-50 text-blue-600"
//                     >
//                       {seat.replace(/^Seats\s*/i, '')}
//                     </span>
//                   ))}
//                 </div>
//               </div>

//               <div className="flex justify-between pt-4 border-t border-gray-200">
//                 <div className="flex items-center">
//                   <div className="w-3 h-3 bg-yellow-400 rounded-full mr-2"></div>
//                   <span className="text-sm">Available: {100 - summaryData.totalBookedSeats}</span>
//                 </div>
//                 <div className="flex items-center">
//                   <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
//                   <span className="text-sm">Sold: {summaryData.totalBookedSeats}</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Bottom Section: Revenue Analytics */}
//       <div className="bg-white rounded-xl shadow-md p-6">
//         <h2 className="text-xl font-semibold mb-4">💹 Revenue Analytics</h2>

//         {/* Filter Controls */}
//         <div className="flex flex-col md:flex-row gap-4 mb-6">
//           <div className="w-full md:w-1/2">
//             <label className="block text-sm font-medium text-gray-700 mb-1">Theatre</label>
//             <select
//               value={selectedTheatre}
//               onChange={(e) => setSelectedTheatre(e.target.value)}
//               className="w-full p-2 border border-gray-300 rounded-md"
//             >
//               {theatres.map((t) => (
//                 <option key={t._id} value={t.name}>{t.name}</option>
//               ))}
//             </select>
//           </div>
//           <div className="w-full md:w-1/2">
//             <label className="block text-sm font-medium text-gray-700 mb-1">Time Period</label>
//             <select
//               value={filterType}
//               onChange={(e) => setFilterType(e.target.value)}
//               className="w-full p-2 border border-gray-300 rounded-md"
//             >
//               <option value="day">Today</option>
//               <option value="week">This Week</option>
//               <option value="month">This Month</option>
//               <option value="year">This Year</option>
//               <option value="custom">Custom</option>
//             </select>
//           </div>
//         </div>

//         {filterType === "custom" && (
//           <div className="flex gap-4 mb-6">
//             <div className="w-1/2">
//               <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
//               <input
//                 type="date"
//                 value={customStartDate || ""}
//                 onChange={(e) => setCustomStartDate(e.target.value)}
//                 className="w-full p-2 border border-gray-300 rounded-md"
//               />
//             </div>
//             <div className="w-1/2">
//               <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
//               <input
//                 type="date"
//                 value={customEndDate || ""}
//                 onChange={(e) => setCustomEndDate(e.target.value)}
//                 className="w-full p-2 border border-gray-300 rounded-md"
//               />
//             </div>
//           </div>
//         )}

//         {/* Summary Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//           <div className="bg-blue-50 p-4 rounded-lg">
//             <h3 className="text-lg font-medium text-blue-800 mb-1">Total Revenue</h3>
//             <p className="text-2xl font-bold text-blue-600">₹{totalEarnings.toLocaleString()}</p>
//           </div>
//           <div className="bg-green-50 p-4 rounded-lg">
//             <h3 className="text-lg font-medium text-green-800 mb-1">Total Tickets Sold</h3>
//             <p className="text-2xl font-bold text-green-600">{totalTickets}</p>
//           </div>
//         </div>

//         {/* Tabs */}
//         <div className="flex border-b border-gray-200 mb-4">
//           <button
//             className={`py-2 px-4 font-medium ${activeTab === 0 ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
//             onClick={() => setActiveTab(0)}
//           >
//             Data Table
//           </button>
//           <button
//             className={`py-2 px-4 font-medium ${activeTab === 1 ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
//             onClick={() => setActiveTab(1)}
//           >
//             Trend Chart
//           </button>
//           <button
//             className={`py-2 px-4 font-medium ${activeTab === 2 ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
//             onClick={() => setActiveTab(2)}
//           >
//             Revenue Breakdown
//           </button>
//         </div>

//         {loading ? (
//           <div className="flex justify-center items-center h-64">
//             <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//           </div>
//         ) : (
//           <>
//             {activeTab === 0 && (
//               <div className="overflow-x-auto">
//                 <table className="min-w-full divide-y divide-gray-200">
//                   <thead className="bg-gray-50">
//                     <tr>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Movie</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Show Time</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Seats</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payment Method</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {paginatedData.map((row, index) => (
//                       <tr key={index}>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDateToDDMMYYYY(row.date)}</td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{row.movieName}</td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{row.showTime}</td>
//                         <td className="px-6 py-4 whitespace-nowrap">
//                           <div className="flex flex-wrap gap-1">
//                             {row.bookedSeats?.map((seat, i) => (
//                               <span key={i} className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800">
//                                 {seat}
//                               </span>
//                             ))}
//                           </div>
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{row.paymentMethod}</td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">₹{row.totalAmount}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//                 <div className="flex items-center justify-between mt-4">
//                   <div className="text-sm text-gray-500">
//                     Showing {page * rowsPerPage + 1} to {Math.min((page + 1) * rowsPerPage, reportData.length)} of {reportData.length} entries
//                   </div>
//                   <div className="flex space-x-2">
//                     <button
//                       onClick={() => setPage(p => Math.max(p - 1, 0))}
//                       disabled={page === 0}
//                       className="px-3 py-1 border rounded-md disabled:opacity-50"
//                     >
//                       Previous
//                     </button>
//                     <button
//                       onClick={() => setPage(p => Math.min(p + 1, Math.ceil(reportData.length / rowsPerPage) - 1))}
//                       disabled={page >= Math.ceil(reportData.length / rowsPerPage) - 1}
//                       className="px-3 py-1 border rounded-md disabled:opacity-50"
//                     >
//                       Next
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {activeTab === 1 && (
//               <div className="h-96">
//                 <h3 className="text-lg font-medium mb-4">Revenue Trend</h3>
//                 <ResponsiveContainer width="100%" height="100%">
//                   <LineChart
//                     data={getAggregatedChartData(reportData, filterType, customStartDate, customEndDate)}
//                     margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
//                   >
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="date" />
//                     <YAxis />
//                     <Tooltip formatter={(value) => [`₹${value}`, 'Revenue']} />
//                     <Legend />
//                     <Line
//                       type="monotone"
//                       dataKey="totalAmount"
//                       name="Revenue"
//                       stroke="#8884d8"
//                       strokeWidth={2}
//                       activeDot={{ r: 8 }}
//                     />
//                   </LineChart>
//                 </ResponsiveContainer>
//               </div>
//             )}

//             {activeTab === 2 && (
//               <div className="h-96">
//                 <h3 className="text-lg font-medium mb-4">Revenue by Movie</h3>
//                 <ResponsiveContainer width="100%" height="100%">
//                   <PieChart>
//                     <Pie
//                       data={getRevenueByMovie()}
//                       cx="50%"
//                       cy="50%"
//                       labelLine={false}
//                       outerRadius={120}
//                       fill="black"
//                       dataKey="value"
//                       nameKey="name"
//                       label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
//                     >
//                       {getRevenueByMovie().map((entry, index) => (
//                         <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                       ))}
//                     </Pie>
//                     <Tooltip formatter={(value) => [`₹${value}`, 'Revenue']} />
//                     <Legend />
//                   </PieChart>
//                 </ResponsiveContainer>
//               </div>
//             )}
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Report;











// Before Akhilesh code

// import React, { useState, useEffect } from "react";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
//   PieChart,
//   Pie,
//   Cell
// } from "recharts";
// import PaymentServices from "../../services/externalServices/TicketServices/paymentServices";
// import TheatreServices from "../../services/externalServices/TicketServices/theatreServices";

// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d'];

// const Report = () => {
//   const [theatres, setTheatres] = useState([]);
//   const [selectedTheatre, setSelectedTheatre] = useState("");
//   const [filterType, setFilterType] = useState("week");
//   const [reportData, setReportData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [customStartDate, setCustomStartDate] = useState(null);
//   const [customEndDate, setCustomEndDate] = useState(null);
//   const [activeTab, setActiveTab] = useState(0);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(100);

//   const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));

//   const isTicketAdmin = role === 'ticket-admin';
//   console.log('isTicketAdmin', isTicketAdmin);
//   const theatreName1 = accessList?.[0]; // assuming accessList contains theatre name


//   useEffect(() => {
//     const fetchTheatres = async () => {
//       try {
//         const res = await TheatreServices.getTheatres();
//         if (Array.isArray(res)) {
//           let filteredTheatres = res;
//           if (role === "ticket-admin") {
//             filteredTheatres = res.filter((theatre) => accessList.includes(theatre.name));
//           }
//           setTheatres(filteredTheatres);
//           if (filteredTheatres.length > 0) {
//             setSelectedTheatre(filteredTheatres[0].name);
//           }
//         }
//       } catch (err) {
//         console.error("Error fetching theatres:", err);
//       }
//     };
//     fetchTheatres();
//   }, []);

//   useEffect(() => {
//     const fetchReport = async () => {
//       if (!selectedTheatre || theatres.length === 0) {
//         setLoading(false);
//         return;
//       }
//       if (filterType === "custom" && (!customStartDate || !customEndDate)) {
//         return;
//       }

//       setLoading(true);
//       try {
//         const response = await PaymentServices.getReports({
//           theatreName: selectedTheatre,
//           filterType,
//           ...(filterType === "custom" && customStartDate && customEndDate
//             ? { startDate: customStartDate, endDate: customEndDate }
//             : {}),
//         });

//         if (Array.isArray(response.data)) {
//           setReportData(response.data);
//         } else {
//           setReportData([]);
//         }
//       } catch (error) {
//         console.error("Error fetching report:", error);
//         setReportData([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchReport();
//   }, [selectedTheatre, filterType, theatres, customStartDate, customEndDate]);

//   const totalEarnings = reportData.reduce((sum, entry) => sum + (entry.totalAmount || 0), 0);
//   const totalTickets = reportData.reduce((sum, entry) => sum + (entry.bookedSeats?.length || 0), 0);

//   const getAggregatedChartData = (data, filterType, customStartDate = null, customEndDate = null) => {
//     const today = new Date();
//     const grouped = {};

//     data.forEach(entry => {
//       const date = new Date(entry.date);
//       const key = date.toISOString().split('T')[0];
//       if (!grouped[key]) grouped[key] = 0;
//       grouped[key] += entry.totalAmount;
//     });

//     const result = [];

//     if (filterType === "yesterday") {
//       const date = new Date(today);
//       date.setDate(today.getDate() - 1);

//       const key = date.toISOString().split('T')[0];
//       const label = `${String(date.getDate()).padStart(2, '0')} ${date.toLocaleString('default', { month: 'short' })} (${date.toLocaleString('default', { weekday: 'short' })})`;

//       result.push({
//         date: label,
//         totalAmount: grouped[key] || 0
//       });
//     }


//   else if (filterType === "week") {
//       for (let i = 6; i >= 0; i--) {
//         const date = new Date(today);
//         date.setDate(today.getDate() - i);
//         const key = date.toISOString().split('T')[0];
//         const label = `${String(date.getDate()).padStart(2, '0')} ${date.toLocaleString('default', { month: 'short' })} (${date.toLocaleString('default', { weekday: 'short' })})`;
//         result.push({
//           date: label,
//           totalAmount: grouped[key] || 0
//         });
//       }
//     } else if (filterType === "month") {
//       const year = today.getFullYear();
//       const month = today.getMonth();
//       const daysInMonth = new Date(year, month + 1, 0).getDate();

//       for (let i = 1; i <= daysInMonth; i++) {
//         const date = new Date(year, month, i);
//         const key = date.toISOString().split('T')[0];
//         const label = `${String(i).padStart(2, '0')} ${date.toLocaleString('default', { month: 'short' })}`;
//         result.push({
//           date: label,
//           totalAmount: grouped[key] || 0
//         });
//       }
//     } else if (filterType === "year") {
//       const year = today.getFullYear();
//       for (let i = 0; i < 12; i++) {
//         const date = new Date(year, i, 1);
//         const key = `${year}-${String(i + 1).padStart(2, '0')}`;
//         const totalForMonth = Object.keys(grouped).reduce((sum, k) => {
//           if (k.startsWith(key)) sum += grouped[k];
//           return sum;
//         }, 0);

//         result.push({
//           date: date.toLocaleString('default', { month: 'short' }),
//           totalAmount: totalForMonth
//         });
//       }
//     } else if (filterType === "custom") {
//       if (!customStartDate || !customEndDate) return [];

//       const start = new Date(customStartDate);
//       const end = new Date(customEndDate);

//       const current = new Date(start);
//       while (current <= end) {
//         const key = current.toISOString().split('T')[0];
//         const label = `${String(current.getDate()).padStart(2, '0')} ${current.toLocaleString('default', { month: 'short' })} (${current.toLocaleString('default', { weekday: 'short' })})`;
//         result.push({
//           date: label,
//           totalAmount: grouped[key] || 0
//         });
//         current.setDate(current.getDate() + 1);
//       }
//     }

//     return result;
//   };

//   const getRevenueByMovie = () => {
//     const revenueByMovie = {};
//     reportData.forEach(entry => {
//       if (!revenueByMovie[entry.movieName]) {
//         revenueByMovie[entry.movieName] = 0;
//       }
//       revenueByMovie[entry.movieName] += entry.totalAmount;
//     });
//     return Object.entries(revenueByMovie).map(([name, value]) => ({
//       name,
//       value
//     }));
//   };

//   const formatDateToDDMMYYYY = (dateInput) => {
//     if (!dateInput) return '';

//     const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
//     if (isNaN(date.getTime())) return 'Invalid date';

//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = date.getFullYear();

//     return `${day}-${month}-${year}`;
//   };

//   const paginatedData = reportData.slice(
//     page * rowsPerPage,
//     page * rowsPerPage + rowsPerPage
//   );

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   return (
//     <div className="bg-white rounded-xl shadow-md p-6">
//       <h2 className="text-xl font-semibold mb-4">💹 Revenue Analytics</h2>

//       {/* Filter Controls */}
//       <div className="flex flex-col md:flex-row gap-4 mb-6">
//         <div className="w-full md:w-1/2">
//           <label className="block text-sm font-medium text-gray-700 mb-1">Theatre</label>
//           <select
//             value={selectedTheatre}
//             onChange={(e) => setSelectedTheatre(e.target.value)}
//             className="w-full p-2 border border-gray-300 rounded-md"
//           >
//             {theatres.map((t) => (
//               <option key={t._id} value={t.name}>{t.name}</option>
//             ))}
//           </select>
//         </div>
//         <div className="w-full md:w-1/2">
//           <label className="block text-sm font-medium text-gray-700 mb-1">Time Period</label>
//           <select
//             value={filterType}
//             onChange={(e) => setFilterType(e.target.value)}
//             className="w-full p-2 border border-gray-300 rounded-md"
//           >
//              <option value="yesterday">Yesterday</option>
//             <option value="day">Today</option>
//             <option value="week">This Week</option>
//             <option value="month">This Month</option>
//             <option value="year">This Year</option>
//             <option value="custom">Custom</option>
//           </select>
//         </div>
//       </div>

//       {filterType === "custom" && (
//         <div className="flex gap-4 mb-6">
//           <div className="w-1/2">
//             <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
//             <input
//               type="date"
//               value={customStartDate || ""}
//               onChange={(e) => setCustomStartDate(e.target.value)}
//               className="w-full p-2 border border-gray-300 rounded-md"
//             />
//           </div>
//           <div className="w-1/2">
//             <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
//             <input
//               type="date"
//               value={customEndDate || ""}
//               onChange={(e) => setCustomEndDate(e.target.value)}
//               className="w-full p-2 border border-gray-300 rounded-md"
//             />
//           </div>
//         </div>
//       )}

//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//         <div className="bg-blue-50 p-4 rounded-lg">
//           <h3 className="text-lg font-medium text-blue-800 mb-1">Total Revenue</h3>
//           <p className="text-2xl font-bold text-blue-600">₹{totalEarnings.toLocaleString()}</p>
//         </div>
//         <div className="bg-green-50 p-4 rounded-lg">
//           <h3 className="text-lg font-medium text-green-800 mb-1">Total Tickets Sold</h3>
//           <p className="text-2xl font-bold text-green-600">{totalTickets}</p>
//         </div>
//       </div>

//       {/* Tabs */}
//       <div className="flex border-b border-gray-200 mb-4">
//         <button
//           className={`py-2 px-4 font-medium ${activeTab === 0 ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
//           onClick={() => setActiveTab(0)}
//         >
//           Data Table
//         </button>
//         <button
//           className={`py-2 px-4 font-medium ${activeTab === 1 ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
//           onClick={() => setActiveTab(1)}
//         >
//           Trend Chart
//         </button>
//         <button
//           className={`py-2 px-4 font-medium ${activeTab === 2 ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
//           onClick={() => setActiveTab(2)}
//         >
//           Revenue Breakdown
//         </button>
//       </div>

//       {loading ? (
//         <div className="flex justify-center items-center h-64">
//           <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//         </div>
//       ) : (
//         <>
//           {activeTab === 0 && (
//             <div className="overflow-x-auto">
//               <table className="min-w-full divide-y divide-gray-200">
//                 <thead className="bg-gray-50">
//                   <tr>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Movie</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Show Time</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Seats</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payment Method</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
//                   </tr>
//                 </thead>
//                 <tbody className="bg-white divide-y divide-gray-200">
//                   {paginatedData.map((row, index) => (
//                     <tr key={index}>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDateToDDMMYYYY(row.date)}</td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{row.movieName}</td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{row.showTime}</td>
//                       <td className="px-6 py-4 whitespace-nowrap">
//                         <div className="flex flex-wrap gap-1">
//                           {row.bookedSeats?.map((seat, i) => (
//                             <span key={i} className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800">
//                               {seat}
//                             </span>
//                           ))}
//                         </div>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{row.paymentMethod}</td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">₹{row.totalAmount}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//               <div className="flex items-center justify-between mt-4">
//                 <div className="text-sm text-gray-500">
//                   Showing {page * rowsPerPage + 1} to {Math.min((page + 1) * rowsPerPage, reportData.length)} of {reportData.length} entries
//                 </div>
//                 <div className="flex space-x-2">
//                   <button
//                     onClick={() => setPage(p => Math.max(p - 1, 0))}
//                     disabled={page === 0}
//                     className="px-3 py-1 border rounded-md disabled:opacity-50"
//                   >
//                     Previous
//                   </button>
//                   <button
//                     onClick={() => setPage(p => Math.min(p + 1, Math.ceil(reportData.length / rowsPerPage) - 1))}
//                     disabled={page >= Math.ceil(reportData.length / rowsPerPage) - 1}
//                     className="px-3 py-1 border rounded-md disabled:opacity-50"
//                   >
//                     Next
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {activeTab === 1 && (
//             <div className="h-96">
//               <h3 className="text-lg font-medium mb-4">Revenue Trend</h3>
//               <ResponsiveContainer width="100%" height="100%">
//                 <LineChart
//                   data={getAggregatedChartData(reportData, filterType, customStartDate, customEndDate)}
//                   margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
//                 >
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey="date" />
//                   <YAxis />
//                   <Tooltip formatter={(value) => [`₹${value}`, 'Revenue']} />
//                   <Legend />
//                   <Line
//                     type="monotone"
//                     dataKey="totalAmount"
//                     name="Revenue"
//                     stroke="#8884d8"
//                     strokeWidth={2}
//                     activeDot={{ r: 8 }}
//                   />
//                 </LineChart>
//               </ResponsiveContainer>
//             </div>
//           )}

//           {activeTab === 2 && (
//             <div className="h-96">
//               <h3 className="text-lg font-medium mb-4">Revenue by Movie</h3>
//               <ResponsiveContainer width="100%" height="100%">
//                 <PieChart>
//                   <Pie
//                     data={getRevenueByMovie()}
//                     cx="50%"
//                     cy="50%"
//                     labelLine={false}
//                     outerRadius={120}
//                     fill="black"
//                     dataKey="value"
//                     nameKey="name"
//                     label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
//                   >
//                     {getRevenueByMovie().map((entry, index) => (
//                       <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                     ))}
//                   </Pie>
//                   <Tooltip formatter={(value) => [`₹${value}`, 'Revenue']} />
//                   <Legend />
//                 </PieChart>
//               </ResponsiveContainer>
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default Report;


// After Akhilesh Code


import React, { useState, useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell
} from "recharts";
import PaymentServices from "../../services/externalServices/TicketServices/paymentServices";
import TheatreServices from "../../services/externalServices/TicketServices/theatreServices";

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d'];

const Report = () => {
  const [theatres, setTheatres] = useState([]);
  const [selectedTheatre, setSelectedTheatre] = useState("");
  const [filterType, setFilterType] = useState("week");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));

  const isTicketAdmin = role === 'ticket-admin';
  console.log('isTicketAdmin', isTicketAdmin);
  const theatreName1 = accessList?.[0]; // assuming accessList contains theatre name


  useEffect(() => {
    const fetchTheatres = async () => {
      try {
        const res = await TheatreServices.getTheatres();
        if (Array.isArray(res)) {
          let filteredTheatres = res;
          // if (role === "ticket-admin") {
          //   filteredTheatres = res.filter((theatre) => accessList.includes(theatre.name));
          // }

          if (role === "ticket-admin") {
            filteredTheatres = res.filter((theatre) => accessList.includes(theatre.name));
          } else if (role === "earnings-report-only") {
            filteredTheatres = res.filter((theatre) => accessList.includes(theatre.name));
          }

          setTheatres(filteredTheatres);
          if (filteredTheatres.length > 0) {
            setSelectedTheatre(filteredTheatres[0].name);
          }
        }
      } catch (err) {
        console.error("Error fetching theatres:", err);
      }
    };
    fetchTheatres();
  }, []);

  useEffect(() => {
    const fetchReport = async () => {
      if (!selectedTheatre || theatres.length === 0) {
        setLoading(false);
        return;
      }
      if (filterType === "custom" && (!customStartDate || !customEndDate)) {
        return;
      }

      setLoading(true);
      try {
        const response = await PaymentServices.getReports({
          theatreName: selectedTheatre,
          filterType,
          ...(filterType === "custom" && customStartDate && customEndDate
            ? { startDate: customStartDate, endDate: customEndDate }
            : {}),
        });

        console.log("response.data", response.data);
        if (Array.isArray(response.data)) {
          setReportData(response.data);
        } else {
          setReportData([]);
        }
      } catch (error) {
        console.error("Error fetching report:", error);
        setReportData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [selectedTheatre, filterType, theatres, customStartDate, customEndDate]);

  const totalEarnings = reportData.reduce((sum, entry) => sum + (entry.totalAmount || 0), 0);
  const totalTickets = reportData.reduce((sum, entry) => sum + (entry.bookedSeats?.length || 0), 0);

  const getAggregatedChartData = (data, filterType, customStartDate = null, customEndDate = null) => {
    const today = new Date();
    const grouped = {};

    data.forEach(entry => {
      const date = new Date(entry.date);
      const key = date.toISOString().split('T')[0];
      if (!grouped[key]) grouped[key] = 0;
      grouped[key] += entry.totalAmount;
    });

    const result = [];

    if (filterType === "yesterday") {
      const date = new Date(today);
      date.setDate(today.getDate() - 1);

      const key = date.toISOString().split('T')[0];
      const label = `${String(date.getDate()).padStart(2, '0')} ${date.toLocaleString('default', { month: 'short' })} (${date.toLocaleString('default', { weekday: 'short' })})`;

      result.push({
        date: label,
        totalAmount: grouped[key] || 0
      });
    }


    else if (filterType === "week") {
      for (let i = 6; i >= 0; i--) {
        const date = new Date(today);
        date.setDate(today.getDate() - i);
        const key = date.toISOString().split('T')[0];
        const label = `${String(date.getDate()).padStart(2, '0')} ${date.toLocaleString('default', { month: 'short' })} (${date.toLocaleString('default', { weekday: 'short' })})`;
        result.push({
          date: label,
          totalAmount: grouped[key] || 0
        });
      }
    } else if (filterType === "month") {
      const year = today.getFullYear();
      const month = today.getMonth();
      const daysInMonth = new Date(year, month + 1, 0).getDate();

      for (let i = 1; i <= daysInMonth; i++) {
        const date = new Date(year, month, i);
        const key = date.toISOString().split('T')[0];
        const label = `${String(i).padStart(2, '0')} ${date.toLocaleString('default', { month: 'short' })}`;
        result.push({
          date: label,
          totalAmount: grouped[key] || 0
        });
      }
    } else if (filterType === "year") {
      const year = today.getFullYear();
      for (let i = 0; i < 12; i++) {
        const date = new Date(year, i, 1);
        const key = `${year}-${String(i + 1).padStart(2, '0')}`;
        const totalForMonth = Object.keys(grouped).reduce((sum, k) => {
          if (k.startsWith(key)) sum += grouped[k];
          return sum;
        }, 0);

        result.push({
          date: date.toLocaleString('default', { month: 'short' }),
          totalAmount: totalForMonth
        });
      }
    } else if (filterType === "custom") {
      if (!customStartDate || !customEndDate) return [];

      const start = new Date(customStartDate);
      const end = new Date(customEndDate);

      const current = new Date(start);
      while (current <= end) {
        const key = current.toISOString().split('T')[0];
        const label = `${String(current.getDate()).padStart(2, '0')} ${current.toLocaleString('default', { month: 'short' })} (${current.toLocaleString('default', { weekday: 'short' })})`;
        result.push({
          date: label,
          totalAmount: grouped[key] || 0
        });
        current.setDate(current.getDate() + 1);
      }
    }

    return result;
  };

  const getRevenueByMovie = () => {
    const revenueByMovie = {};
    reportData.forEach(entry => {
      if (!revenueByMovie[entry.movieName]) {
        revenueByMovie[entry.movieName] = 0;
      }
      revenueByMovie[entry.movieName] += entry.totalAmount;
    });
    return Object.entries(revenueByMovie).map(([name, value]) => ({
      name,
      value
    }));
  };

  const formatDateToDDMMYYYY = (dateInput) => {
    if (!dateInput) return '';

    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    if (isNaN(date.getTime())) return 'Invalid date';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const paginatedData = reportData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return 'N/A';

    // Remove all non-digit characters
    const cleaned = phone.toString().replace(/\D/g, '');

    // Check if it's an Indian number (starts with 91 or without country code)
    if (cleaned.length === 10) {
      return `+91 ${cleaned.slice(0, 5)} ${cleaned.slice(5)}`;
    }
    if (cleaned.length === 12 && cleaned.startsWith('91')) {
      return `+${cleaned.slice(0, 2)} ${cleaned.slice(2, 7)} ${cleaned.slice(7)}`;
    }

    // Fallback for other formats
    return `+${cleaned}`;
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h2 className="text-xl font-semibold mb-4">💹 Revenue Analytics</h2>

      {/* Filter Controls */}
      <div className="flex flex-col md:flex-row gap-4 mb-6">
        <div className="w-full md:w-1/2">
          <label className="block text-sm font-medium text-gray-700 mb-1">Theatre</label>
          <select
            value={selectedTheatre}
            onChange={(e) => setSelectedTheatre(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md"
          >
            {theatres.map((t) => (
              <option key={t._id} value={t.name}>{t.name}</option>
            ))}
          </select>
        </div>
        <div className="w-full md:w-1/2">
          <label className="block text-sm font-medium text-gray-700 mb-1">Time Period</label>
          <select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md"
          >

            <option value="day">Today</option>
            <option value="yesterday">Yesterday</option>
            <option value="week">This Week</option>
            <option value="month">This Month</option>
            <option value="year">This Year</option>
            <option value="custom">Custom</option>
          </select>
        </div>
      </div>

      {filterType === "custom" && (
        <div className="flex gap-4 mb-6">
          <div className="w-1/2">
            <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
            <input
              type="date"
              value={customStartDate || ""}
              onChange={(e) => setCustomStartDate(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>
          <div className="w-1/2">
            <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
            <input
              type="date"
              value={customEndDate || ""}
              onChange={(e) => setCustomEndDate(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>
        </div>
      )}

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div className="bg-blue-50 p-4 rounded-lg">
          <h3 className="text-lg font-medium text-blue-800 mb-1">Total Revenue</h3>
          <p className="text-2xl font-bold text-blue-600">₹{totalEarnings.toLocaleString()}</p>
        </div>
        <div className="bg-green-50 p-4 rounded-lg">
          <h3 className="text-lg font-medium text-green-800 mb-1">Total Tickets Sold</h3>
          <p className="text-2xl font-bold text-green-600">{totalTickets}</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex border-b border-gray-200 mb-4">
        <button
          className={`py-2 px-4 font-medium ${activeTab === 0 ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
          onClick={() => setActiveTab(0)}
        >
          Data Table
        </button>
        <button
          className={`py-2 px-4 font-medium ${activeTab === 1 ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
          onClick={() => setActiveTab(1)}
        >
          Trend Chart
        </button>
        <button
          className={`py-2 px-4 font-medium ${activeTab === 2 ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
          onClick={() => setActiveTab(2)}
        >
          Revenue Breakdown
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      ) : (
        <>
          {activeTab === 0 && (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone Number</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Movie</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Show Time</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Seats</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payment Method</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {paginatedData.map((row, index) => (
                    <tr key={index}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDateToDDMMYYYY(row.date)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500">
                        {formatPhoneNumber(row.userPhoneNumber)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{row.movieName}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{row.showTime}</td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex flex-wrap gap-1">
                          {row.bookedSeats?.map((seat, i) => (
                            <span key={i} className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800">
                              {seat}
                            </span>
                          ))}
                        </div>
                      </td>
                      {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{row.paymentMethod}</td> */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {row.paymentMethod === 'Cash' ? 'COUNTER' : row.paymentMethod}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">₹{row.totalAmount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="flex items-center justify-between mt-4">
                <div className="text-sm text-gray-500">
                  Showing {page * rowsPerPage + 1} to {Math.min((page + 1) * rowsPerPage, reportData.length)} of {reportData.length} entries
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => setPage(p => Math.max(p - 1, 0))}
                    disabled={page === 0}
                    className="px-3 py-1 border rounded-md disabled:opacity-50"
                  >
                    Previous
                  </button>
                  <button
                    onClick={() => setPage(p => Math.min(p + 1, Math.ceil(reportData.length / rowsPerPage) - 1))}
                    disabled={page >= Math.ceil(reportData.length / rowsPerPage) - 1}
                    className="px-3 py-1 border rounded-md disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 1 && (
            <div className="h-96">
              <h3 className="text-lg font-medium mb-4">Revenue Trend</h3>
              <ResponsiveContainer width="100%" height="100%">
                <LineChart
                  data={getAggregatedChartData(reportData, filterType, customStartDate, customEndDate)}
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" />
                  <YAxis />
                  <Tooltip formatter={(value) => [`₹${value}`, 'Revenue']} />
                  <Legend />
                  <Line
                    type="monotone"
                    dataKey="totalAmount"
                    name="Revenue"
                    stroke="#8884d8"
                    strokeWidth={2}
                    activeDot={{ r: 8 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          )}

          {activeTab === 2 && (
            <div className="h-96">
              <h3 className="text-lg font-medium mb-4">Revenue by Movie</h3>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={getRevenueByMovie()}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    outerRadius={120}
                    fill="black"
                    dataKey="value"
                    nameKey="name"
                    label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                  >
                    {getRevenueByMovie().map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip formatter={(value) => [`₹${value}`, 'Revenue']} />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Report;












